<template>
  <div>
    <!-- 口座振替の場合 -->
    <div v-if="user.role && user.role.role === 7">
      <h2>定期購読変更</h2>
      <Spacer :y="6"/>
      <p>口座振替にて桐生タイムスを御購読の場合、プランの変更や解約をWEB上からお手続きいただけません。<br>お手数ですが、お問合せフォームまたはお電話にてお問合せください。</p>
      <Spacer :y="4"/>
        <div :class="$style.btns">
          <router-link
            :class="[$style.btn, $style.primary]"
            to="/">トップページに戻る</router-link>
        </div>
    </div>

    <!-- 通常 -->
    <div :class="$style.wrap" v-else-if="user.email">
      <h2>定期購読{{ user.statusFlags.isUnderContract ? 'プラン変更' : 'お申し込み' }}</h2>
      <Spacer :y="6"/>
      <!-- 上部step表示 -->
      <div v-if="!user.statusFlags.isUnderContract">
        <ul :class="$style.steps">
          <li
            :class="[$style.step,  step.done_page_names.includes(s.page_name) ? $style.done : '']"
            v-for="(s, i) in steps"
            :key="s">
            <div :class="$style.step_num">
              <span v-if="i + 1 > step">{{ i + 1 }}</span>
              <span v-else><i class="fa-regular fa-circle-check"></i></span>
            </div>
            <p :class="$style.step_label">{{ s.label_short }}</p>
          </li>
        </ul>
        <Spacer :y="6"/>
        <h5>{{ step?.label }}</h5>
        <Spacer :y="2"/>
      </div>

      <!-- コンテンツ -->
        <!-- v-if="user.id && helper.master?.products" -->
      <router-view
        :selectedCourse="selectedCourse"
        :customerDefaultSource="customerDefaultSource"
        :deliveryAddress="deliveryAddress"
        :styleClasses="styleClasses"
        :courseData="plans"
        :cancelData="cancelData"
        :planLoaded="flag.planLoaded"
        @handleLoading="handleLoading($event)"
        @changeCourse="changeCourse($event)"
        @handleCancelData="handleCancelData($event)"
        @registSubscription="submit" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import moment from 'moment';
import cf from '@/mixins/commonFunctions.js';
import Spacer from '@/components/Spacer';
import subscriptionSteps from '@/data/subscription/steps.yaml';


export default {
  name: 'subscription',
  mixins: [cf],
  components: {
    Spacer,
  },
  data() {
    return {
      root2: Math.sqrt(2), //  styleで使用
      flag: {
        planLoaded: false,
      },
      cancelData: {
        name: '',
        address: '',
        tel: '',
        method: '',
      },
      plans: {
        web: {},
        webPaper: {},
        paper: {},
      },
      product: null,
      tax: null,
      selectedCourse: null,
    };
  },
  created() {
    if (['web', 'webPaper', 'paper'].includes(this.$route.query.plan)) this.selectedCourse = this.$route.query.plan;
    if (this.user.id) this.selectedCourse = this.user.customer?.subscriptions[0]?.planName || null;
    this.checkStatus();
    this.getSubscriptionData();
  },
  async mounted() {
    const query = this.$route.query;
    if (query.plan) this.coursename = query.plan;
  },
  watch: {
    'user.id': {
      handler() {
        this.selectedCourse = this.user.customer?.subscriptions[0]?.planName || null;
      },
    },
    'helper.master.products': {
      handler() {
        this.checkStatus();
        this.getSubscriptionData();
      },
    },
    $route: {
      handler() {
        this.checkStatus();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['user', 'helper']),
    steps() {
      return subscriptionSteps.filter((step) => step.label_short !== '配送先' || !this.selectedCourse || this.selectedCourse.toLowerCase().includes('paper'));
    },
    styleClasses() {
      return this.$style;
    },
    pageName() {
      return this.$route.meta.name;
    },
    step() {
      return this.steps.find((s) => s.page_name === this.pageName);
    },
    customerDefaultSource() {
      if (!this.user.customer?.customer_id || !this.user.subscribe.cards.flag) return null;
      const target = this.user.subscribe.cards.default || this.user.subscribe.cards.oldDefault || null;
      const card = target ? this.user.subscribe.cards.cards.find((c) => c.id === target) : null;
      return card ? {
        id: card?.id || null,
        brand: card?.brand || null,
        last4: card?.last4 || null,
        isCertified: true,
      } : null;
    },
    deliveryAddress() {
      const address = this.user.address?.find((addr) => addr.type === 2);
      return address ? {
        label: `${address.city}${address.address} ${address.building || ''}`,
        obj: address,
      } : null;
    },
  },

  methods: {
    getSubscriptionData() {
      if (!this.helper.master.products) return;
      const env = this.helper.env.name;

      const params = {
        subscription_id: this.helper.master.products.product_id[env],
      };

      this.axios({
        method: 'GET',
        url: 'v1/stripe/subscription/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.product = res.product;
          this.tax = res.tax;
          res.prices.data = res.prices.data.filter((price) => price.active);
          this.plans = Object.fromEntries(res.prices.data.map((price) => [price.nickname, price]) || []);
          // [TODO] 契約中の場合該当のプランを選択状態にしたい
          this.flag.planLoaded = true;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
        });

      if (this.deliveryAddress) {
        this.flag.readyAddress = true;
      }
    },

    changeCourse(coursename) {
      this.selectedCourse = coursename;
    },

    checkStatus() {
      const pageType = this.$route.meta.name;
      // 有料登録済みの場合、プランの変更のみ可
      if (this.user.statusFlags.isUnderContract && pageType !== 'plan') this.$router.push('/edit/subscription/');
    },

    handleLoading(type) {
      if (type === 'show') this.showLoading();
      if (type === 'hide') this.hideLoading();
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    updateEditFlag(type, target) {
      if (type === 'address') {
        this.flag.editAddress[target] = !this.flag.editAddress[target];
        if (this.adjustAddress(2)) this.flag.readyAddress = true;
      } else {
        this.flag.editCard = !this.flag.editCard;
      }
    },

    adjustAddress(type) {
      if (this.user && this.user.address) {
        const addressArray = this.user.address.filter((addr) => addr.type === type);
        if (!addressArray.length) return null;
        const address = addressArray[0];
        const label = type === 2
          ? `${address.city}${address.address} ${address.building || ''}`
          : `〒${address.zip} ${address.pref}${address.city}${address.address} ${address.building || ''}`;
        return {
          label,
          flag: address.flag,
        };
      }
      return null;
    },

    submit() {
      if (!confirm('お支払いを確定します。よろしいですか？')) return;
      this.showLoading();
      if (this.user.customer) {
        this.registSubscription(this.user.customer.customer_id);
      } else {
        alert('カスタマー情報の取得に失敗しました。');
      }
    },

    registSubscription(customerId) {
      const name = this.selectedCourse;
      const data = {
        // isExist: false, // 今回使うカード情報がすでに登録済の場合true
        // ignoreSoldOut: this.data.ignoreSoldOut || false,
        user_id: this.user.id,
        productObj: this.product,
        priceObj: this.plans[name],
        taxObj: this.tax,
        customer_id: customerId,
        customer: {
          email: this.user.email,
          name: `${this.user.last_name} ${this.user.first_name}`,
        },
        connected_account_id: this.product.metadata?.connected_account_id ? this.product.metadata.connected_account_id : null,
      };

      if (this.user.limit_trial && moment(this.user.limit_trial).isSameOrAfter(new Date(), 'day')) {
        data.limit_trial = this.user.limit_trial;
      }

      // 支払いを実行
      try {
        this.axios({
          method: 'POST',
          url: '/v1/stripe/subscription/set/register',
          data,
        })
          .then((response) => {
            const res = response.data;
            if (res && res.registedSubscription) {
              alert('お申し込みが完了しました。');
              this.$store.dispatch('user/update', null, { root: true });
              const customerData = { customer: { customer_id: customerId } };
              this.$store.dispatch('user/subscribe/getCustomer', customerData, { root: true });
              // これでリロードしないとその後のカード追加登録がうまくいかない
              // this.$router.push({ path: '/account/' });
              /** 既存契約の解約情報登録 */
              if (this.cancelData.name) {
                this.registCancelData();
              } else {
                this.$router.push('/account/');
                this.hideLoading();
              }
            } else {
              this.$router.push('/account/');
              this.hideLoading();
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.data);
              alert(`定期購入の登録に失敗しました。\n失敗の理由については以下サイトをご参照くださいませ。\nhttps://stripe.com/docs/declines/codes\nエラー内容: ${error.response.data.detail}`);
            } else {
              console.log(error);
            }
            this.hideLoading();
          });
      } catch (err) {
        if (err.response) console.log(err.response.data);
        else console.log(err);
        alert('お支払い情報の登録に失敗しました。\nお手数ですが管理者までお問い合わせください');
        this.hideLoading();
      }
    },

    handleCancelData(e) {
      this.cancelData = e;
    },

    /** 既存契約の解約情報登録 */
    async registCancelData() {
      const tempValues = [];
      const checkColumns = [
        {
          column: 'name',
          type: 4,
        },
        {
          column: 'address',
          type: 5,
        },
        {
          column: 'tel',
          type: 6,
        },
        {
          column: 'method',
          type: 7,
        },
      ];
      // 必要な項目を確認
      checkColumns.forEach((row) => {
        tempValues.push({
          type: row.type,
          user_id: this.user.id,
          value: this.cancelData[row.column],
        });
      });
      await Promise.all(
        tempValues.map(async (row) => {
          await this.axios({
            method: 'POST',
            url: '/v1/temporary/set/register',
            data: row,
          })
            .then(() => {
            })
            .catch((error) => {
              alert('紙面プラスプランの解約情報登録に失敗しました。お手数ですが、管理者へお問い合わせください。');
              if (error.message) console.log(error.message);
              else console.log(error);
            })
            .finally(() => {
              this.hideLoading();
              this.$router.push('/account/');
            });
        }),
      );
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  max-width: 500px;
  margin: 0 auto;
}

.steps {
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  .step {
    flex: 1;
    border-width: 1px;
    border-style: solid;
    border-color: var(--lightgray) var(--lightgray) var(--lightgray) transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    padding: 12px;
    color: var(--lightgray);

    &:not(:last-child) {
      position: relative;
      &::after {
        $l: 15px;
        content: '';
        position: absolute;
        display: block;
        top: 50%;
        right: 0;
        width: $l;
        height: $l;
        transform: translate(calc($l / v-bind(root2) + ($l - $l * v-bind(root2)) / 2), -50%) rotate(45deg);
        background-color: white;
        border-width: 1px;
        border-style: solid;
        border-color: var(--lightgray) var(--lightgray) transparent transparent;
      }
    }

    &:first-child {
      border-left: 1px solid var(--lightgray);
    }

    &.done {
      color: var(--gray);
      border-color: var(--gray) var(--gray) var(--gray) transparent;

      &::after {
        border-color: var(--gray) var(--gray) transparent transparent;
      }

      &:first-child {
        border-color: var(--gray) var(--gray) var(--gray) var(--gray);
      }
    }

    &_num {
      margin-bottom: 8px;
    }

    &_label {
      font-size: 12px;
      line-height: 1;
      margin-left: 4px;
    }
  }
}


.delivery {
  margin-bottom: 24px;
  &_label {
    font-size: 20px;
  }
}

.btns {
  display: flex;
  justify-content: center;
  > *:not(:first-child) {
    margin-left: 12px;
  }
}

.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 128px;
  height: 40px;
  padding: 13px 26px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1;
  border-radius: 20px;
  cursor: pointer;
  appearance: none;
  box-shadow: none;
  transition: all .3s;

  &.primary {
    background-color: rgba(26, 34, 61, 1);
    border: none;
    color: #fff;
    a {
      color: #fff;
    }
    &:hover, &:disabled {
      opacity: .6;
      cursor: default;
    }
  }

  &.secondary {
    border: 1px solid rgba(26, 34, 61, 1);
    color: var(--font-black);
    background-color: #fff;
    &:hover {
      opacity: .4;
    }
  }
}

.notNow {
  font-size: 12px;
  color: var(--gray);
  text-decoration: underline;
  cursor: pointer;
}

.plan_list {
  li {
    margin-bottom: 32px;
  }
}

.label {
  border: 1px solid #858585;
  border-radius: 4px;
  width: 100%;
  color: var(--gray);

  &_title {
    padding: 15px 32px;
    background-color: #858585;
    color: #fff;
    text-align: center;
    font-size: 22px;
  }

  .assistant {
    padding: 0 32px;
    font-size: 12px;
    display: flex;
    flex-flow: column;
    align-items: center;

    i {
      font-size: 16px;
      color: green;
      margin-right: 4px;
    }
  }

  &_current {
    font-size: 12px;
    color: var(--gray);
  }

  &.selected {
    border-color: var(--black);
    border-width: 1.5px;
    color: var(--black);

    .label_title {
      background-color: var(--black);
    }
  }
  .price {
    display: flex;
    align-items: center;
    &_wrap {
      display: flex;
      justify-content: center;
    }
    @include xs-view {
      flex-flow: column;
    }
  }

  .default {
    font-size: 24px;
    &.notDefault {
      position: relative;
      &::after {
        content: '';
        width: 100%;
        height: 2px;
        background-color: var(--font-black);
        position: absolute;
        top: 50%;
        left: 0;
      }
    }
  }

  .arrow {
    margin-left: 26px;
    font-size: 24px;
    &.right {
      @include xs-view {
        display: none;
      }
    }
    &.down {
      margin-left: 0;
      display: none;
      @include xs-view {
        display: inline-block;
      }
    }
  }

  .trial {
    margin-left: 16px;
    display: flex;
    flex-flow: column;
    align-items: center;
    &_assistant {
      font-size: 14px;
    }
    &_price {
      font-size: 26px;
      .zero {
        font-size: 37px;
        line-height: 1;
      }
    }
    &_des {
      font-size: 12px;
    }
    @include xs-view {
      margin-left: 0;
      margin-top: 12px;
    }
  }
}

.confirmList {
  border: 1px solid var(--gray);
}

.itemname {
  background-color: var(--lightgray);
  padding: 4px 10px;
  font-size: 12px;
  font-weight: bold;
}

.detail {
  padding: 12px 16px;
}

.cancel {
  margin: 0 auto;
  display: inline-block;
  text-decoration: underline;
  color: var(--black);
  cursor: pointer;
}

.onlyPC {
  @include xs-view {
    display: none;
  }
}

.onlySP {
  display: none;
  @include xs-view {
    display: inline-block;
  }
}
.radio {
  &_wrap {
    display: flex;
    flex-wrap: wrap;
  }

  margin-bottom: 4px;

  &:not(:last-child) {
    margin-right: 4px;
  }

  &_label {
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid var(--lightgray);
    color: var(--gray);
    &.checked {
      border-color: var(--gray);
      color: var(--black);
    }
  }
  &_right {
    margin: 0 0 0 auto;
  }
}
@include sm-view {
  .stop_input {
    width: 100%;
  }
}

.warning {
  font-size: 12px;
  color: var(--red);
}

</style>
